jQuery(document).ready(function($) {
    // Remove aria-hidden from slider items in recent posts
    $('.sc-recent-posts .slider-item').removeAttr('aria-hidden');
    $('.slider-crosssell .slider-item').removeAttr('aria-hidden');
    // Remove aria-hidden from all li elements under slick-dots
    $('.slick-dots li').removeAttr('aria-hidden');
});